import { createReducer } from '@reduxjs/toolkit';
import { lifecycleSurveyTypesActions } from '~/behaviors/actions/lifecycleSurveyTypes.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {};

const reset = () => defaultState;

const replace = (state, action) => {
  return action?.payload || defaultState;
};

const lifecycleSurveyTypes = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(lifecycleSurveyTypesActions.getLifecycleSurveyTypes.fulfilled, replace);
});

export default lifecycleSurveyTypes;
